import { PropsWithChildren, useCallback } from "react";
import Carousel from "../Carousel";
import ImageOrVideo from "../ImageOrVideo";
import { cmsUrl } from "../../utils/CmsUtils";
import { useMediaQuery } from "react-responsive";
import { Asset } from "../../types/Asset";
import "./scroll-gallery.scss";

const ScrollGallery = ({
  images = [],
  startIndex = 0,
  children
}: PropsWithChildren<{
  images: Asset[];
  startIndex?: number;
}>) => {
  const isSmallScreen = useMediaQuery({ maxWidth: "600px" });

  const previewItems = images?.map(image => {
    return {
      image: true,
      path:
        image.styles?.px1920 ||
        image.styles?.medium ||
        cmsUrl("/storage/uploads" + image.path),
      colors: image.colors
    };
  });

  const renderSlide = useCallback(
    (image: object, i: number) => (
      <div className={"carousel-slide"} key={i}>
        <ImageOrVideo image={image as Asset} keepAspectRatio />
      </div>
    ),
    []
  );

  if (!images) return null;

  return (
    <div className={"scroll-gallery"}>
      {previewItems.length > 1 && (
        <Carousel
          direction="horizontal"
          showMarkers
          hideButtons={isSmallScreen}
          centeredButtons
          navType="arrows"
          startOverAtEnd
          startIndex={startIndex}
          slidesData={previewItems}
          renderSlide={renderSlide}
        />
      )}
      {children}
    </div>
  );
};

export default ScrollGallery;
